<template>
    <div>
        <template v-if="view == 'index'">
            <spinner v-if="loading.history"></spinner>
            <div style="overflow:hidden;" v-else>
                <vue-good-table :columns="columns"
                                :rows="messages"
                                :pagination-options="{'enabled': true}">
                    <div slot="emptystate">
                        No emails available.
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'status'"><span class="label label-sm" :class="[props.row.status == 3 ? 'label-danger' : 'label-warning']"> {{ statuses[props.row.status] }} </span></span>
                        <template v-else-if="props.column.field =='actions'">
                            <button class="btn btn-xs green" @click="viewEmail(props.row.id)">View</button>
                        </template>
                        <span v-else-if="props.column.field=='sent_at.date'"><template v-if="props.row.sent_at">{{ props.row.sent_at.date | formatDate }}</template></span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                </vue-good-table>
            </div>
        </template>
        <template v-else-if="view == 'viewEmail'">
            <edit-email v-on:back="switchToIndex"></edit-email>
        </template>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import Spinner from "@/components/Spinner";
    import EditEmail from "./EditEmail";

    export default {
        components: {
            EditEmail,
            Spinner,
        },
        data() {
            return {
                view: 'index',
                showAddFormModal: false,
                formPublish: true,
                formAccounts: [],
                columns: [
                    {
                        label: 'Subject',
                        field: 'subject',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Timestamp',
                        field: 'sent_at.date',
                        sortFn: this.dateSortFn,
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Created By',
                        field: 'created_by',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        sortFn: this.statusSortFn,
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Actions',
                        field: 'actions',
                        sortable: false

                    }
                ],
                viewEmailId: null,
                statuses: {
                    0: 'Drafting',
                    1: 'Sending',
                    2: 'Sent',
                    3: 'Warning'
                }
            }
        },

        computed: {
            ...mapGetters({
                appUser: 'getUser',
                messages: 'emails/getHistory',
                loading: 'emails/getLoading'
            }),
        },

        mounted() {
            this.fetchHistory();
        },

        methods: {
            ...mapActions('emails', [
                'fetchHistory',
                'fetchEmail'
            ]),

            switchToIndex() {
                this.fetchHistory();
                this.view = 'index';
            },

            viewEmail(id) {
                this.view = 'viewEmail';
                this.fetchEmail(id);
            },

            dateSortFn(x, y, col, rowX, rowY) {
                let xDate = moment(x).unix();
                let yDate = moment(y).unix();
                return (xDate < yDate ? -1 : (xDate > yDate ? 1 : 0));
            },

            statusSortFn(x, y, col, rowX, rowY) {
                return (x < y ? -1 : (x > y ? 1 : 0));
            }
        },

        inject: {
            $validator: '$validator'
        },
    }
</script>



// WEBPACK FOOTER //
// EmailHistoryIndex.vue?4f464c18